import React from "react";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <div className="access-denied-page">
      <div className="access-denied-box">
        <h1>Access Denied</h1>
        <p>
          Unfortunately, your access to this service is no longer valid. This might be due to:
        </p>
        <ul className="reason-list">
          <li>Your reservation has ended (checked out or departed)</li>
          <li>Invalid or expired reservation code</li>
          <li>You are not an authorized guest for this reservation</li>
        </ul>
        <p className="support-info">
          If you believe this is an error, please contact the hotel reception for assistance.
        </p>
        <a href="tel:021120033010" className="access-denied-btn">
          📞 Call Reception: 02102 154150
        </a>
      </div>
    </div>
  );
};

export default AccessDenied;
